var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFramelessMapIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 249,
    height: 248,
    viewBox: "128 111 10 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100 100)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#4a90e2",
    strokeWidth: 2,
    fill: "white",
    d: "M24 12c5.239 0 9.5 4.119 9.5 9.181 0 5.697-8.577 15.33-8.663 15.427A1.122 1.122 0 0 1 24 37c-.313 0-.61-.14-.836-.392-.087-.096-8.664-9.73-8.664-15.427C14.5 16.12 18.762 12 24 12zm-.18 36.067c2.144 0 3.883-1.72 3.883-3.843s-1.739-3.843-3.883-3.843c-2.145 0-3.884 1.72-3.884 3.843s1.739 3.843 3.884 3.843z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFramelessMapIcon);
export default __webpack_public_path__ + "static/media/frameless-map-icon.1c4119ab167d50b9194233454c79bfcc.svg";
export { ForwardRef as ReactComponent };